import { identity } from 'lodash-es';
import { EMBED_CONFIGURATION_SERVICE_BASEURL } from 'config';
import ServiceFactory from 'services/ServiceFactory';
import {
  EMBED_CONFIGURATION_PATH_V1,
  WIDGET_CONFIGURATION_PATH,
} from './constants';
import { LOCKSPEC_DETAIL_PATH } from './constants';
import { EmbedConfig, GetWidgetConfigurationArgs, WidgetConfig } from './types';
import { GetLockSpecArgs, LockSpecResult } from './types';

const serviceFactory = new ServiceFactory(EMBED_CONFIGURATION_SERVICE_BASEURL);

/**
 * Create widget configuration
 */
export const createWidgetConfiguration = serviceFactory.createPostEndpoint(
  EMBED_CONFIGURATION_PATH_V1,
)<EmbedConfig, WidgetConfig>({
  data: identity,
});

/**
 * Retrieve configuration by widget id
 *
 * Special image types can be found in the following locations:
 *  - slide show (image)
 *  - watermark
 *
 * Special text types can be found in the following locations:
 *  - slide show (image) image effect option’s embedded text
 *  - text overlay
 */
export const getWidgetConfiguration = serviceFactory.createGetEndpoint(
  WIDGET_CONFIGURATION_PATH,
)<GetWidgetConfigurationArgs, WidgetConfig>();

/*
 * Retrieve lockspec by id
 */
export const getLockSpec = serviceFactory.createGetEndpoint(
  LOCKSPEC_DETAIL_PATH,
)<GetLockSpecArgs, LockSpecResult>();
